// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AcceptCookie_wrapper__1oxzO","text":"AcceptCookie_text__2RitE","button":"AcceptCookie_button__12O6A"};